import { useState } from 'react';

import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useTranslation } from '../../../../hooks/useTranslation';
import { usePhoneTypeOptions } from './usePhoneTypeOptions';
import { ValidatedMultiStringValueInputProps } from '../types';

export const MultiPhoneTypeSelect = ({
  onChange,
  value,
  isInvalid,
  isOpenByDefault,
  hasWarning,
  dataType,
  field,
  fieldType,
  comparator,
  optionsLimit,
}: ValidatedMultiStringValueInputProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const options = usePhoneTypeOptions({ search });
  const { isReadOnly } = useQueryStateContext();
  const { ConditionValueMultiStringSelect: VisualComponent } = useVisualComponentsContext();

  return (
    <VisualComponent
      comparator={comparator}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      hasError={!!isInvalid}
      hasWarning={hasWarning}
      isOpenByDefault={isOpenByDefault}
      isDisabled={!!isReadOnly}
      search={search}
      setSearch={setSearch}
      onChange={onChange}
      options={options}
      optionsLimit={optionsLimit}
      value={value}
      placeholder={t('v2.conditionBuilder.multiPhoneTypePlaceholder')}
    />
  );
};
